import Vue from 'vue';
import Component from 'vue-class-component';
import Ribbon from '@/core/ribbon/ribbon.vue';
import DsNavbar from '@/core/ds-navbar/ds-navbar.vue';
import ShowMore from '@/shared/cards/footer/show-more/show-more.vue';

import '@/shared/config/dayjs';
import { Inject, Provide, Watch } from 'vue-property-decorator';
import TranslationService from '@/locale/translation.service';
import { PrincipalService } from '@/service/principal.service';
import axios from 'axios';
import { UserActivityLogModel } from '@/shared/model/user-activity-log.model';
import { namespace } from 'vuex-class';
import {
  DUE_DATE_MAKE_A_THON,
  LOADING_DATA_TYPE,
  MAX_TIME_OUT_FOR_LOADING_REPORT,
  REPORT_TOAST_STATUS,
  REPORT_TOAST_STATUS_CODE,
  SERVER_API_URL,
  TIME_CHECK_LOADING_REPORT,
  TIME_DISPLAY_SUCCESS_TOAST_REPORT,
} from '@/constants';
import LogOutModal from '@/account/logout/logout.vue';
import PopupAddReference from '@/entities/briefing/reference/popup-add-reference/popup-add-reference.vue';
import MyBriefingSidebar from '@/core/ds-navbar/my-briefing-sidebar/my-briefing-sidebar.vue';
import Register from '@/account/register/register.vue';
import ArticleDetail from '@/entities/article-detail/artical-detail.vue';
import myReports from '@/entities/report-insights/my-report-detail.vue';
import myTopics from '@/entities/topic-insights/my-topic-detail.vue';
import type { IResourceModel } from '@/shared/model/briefing-widget.model';
import PopupUpdateBriefing from '@/v2/shared/update-briefing/popup-update-briefing.vue';
import PopupAlertPinComponent from '@/shared/popup/pop-up-litmit-pin/popup-alert-pin.vue';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import GoToTopComponent from '@/shared/go-to-top-button/go-to-top.vue';
import DsNavbarGuest from '@/core/ds-navbar-guest-user/ds-navbar-guest.vue';
import ShareReport from '@/entities/report-insights/share-report/share-report.vue';
import MyReportSidebar from '@/core/ds-navbar/my-report-sidebar/my-report-sidebar.vue';
import PopupEditReportRef from '@/entities/report-insights/popup-edit-report-reference/popup-edit-report-ref.vue';
import PopupReportDetailSettingComponent from '@/entities/report-insights/popup-report-detail-setting/popup-report-type-setting.vue';
import PopupReportWarningCloseAfterEditComponent from '@/entities/report-insights/popup-report-warning-close-after-edited/popup-report-warning-close-after-edit.vue';
import ShareTopic from '@/entities/topic-insights/share-topic/share-topic.vue';
import PopupPluginDownload from '@/core/ds-navbar/popup-plugin-download/popup-plugin-download.vue';
import ReportToastComponent from '@/shared/toast/report-toast/report-toast.vue';
import { BriefingReportSubscribe, ToastReportData } from '@/shared/model/briefing-resource.model';
import { map2ResourceItem } from '@/util/mapper-utils';
import { Subscription } from 'rxjs';
import WebsocketService from '@/service/websocket.service';
import LoadingReportCardUtil from '@/util/loading-report-card.util';
import ReportToastUtil from '@/util/report-toast.util';
import GoListEndComponent from '@/shared/cards/footer/go-list-end/go-list-end.vue';
import PopupMakeAThonComponent from '@/shared/popup/popup-make-a-thon/popup-make-a-thon.vue';
import PopupSubmitReportComponent from '@/shared/popup/submit-report/popup-submit-report.vue';
import PopupSubmitReportSuccessComponent from '@/shared/popup/submit-report-success/popup-submit-report-success.vue';
import CompanyWidgetViewDetail from '@/shared/cards/briefing/company-widget-view-detail/company-widget-view-detail.vue';
import { mapGetters } from 'vuex';
import { isOutOfDateMakeAThon } from '@/util/ds-util';
import LoginForm from '@/account/login/popup-login.vue';
import PopupRequiredLoginComponent from '@/shared/popup/popup-required-login/popup-required-login.vue';
import ScrapAgent from '@/entities/scrap-agent/scrap-agent.vue';
import { dataEvents } from '@/shared/model/scrap-agent.model';
import PopupRequiredPaidAccountComponent from '@/shared/popup/popup-required-paid-account/popup-required-paid-account.vue';
import ModalCreateAgentComponent from '@/v2/shared/create-agent/modal-create-agent.vue';
import PopupTrialUserComponent from '@/v2/components/payment/popup-trial-user/popup-trial-user.vue';
import FeatureLimit from '@/v2/components/payment/feature-limit/feature-limit.vue';
import MyCreateSidebar from '@/v2/my-create/sidebar/my-create-sidebar.vue';
import PopupSystemUpgrade from '@/shared/popup/popup-system-upgrade/popup-system-upgrade.vue';
import { checkIsGuestAccount } from '@/util/guest-util';
import PublicService from '@/service/public.service';

const briefingStore = namespace('briefingStore');
const appStoreState = namespace('appStore');

const groupsManagerStore = namespace('groupsManagerStore');

declare global {
  interface Window {
    ZoomChartsLicense: string;
    ZoomChartsLicenseKey: string;
  }
}

// window.ZoomChartsLicense = 'ZCP-e3dr7u1hj: ZoomCharts SDK Internal Use license for DeepSignal, LLC. Valid for 1 chart developer and EVSL';
// window.ZoomChartsLicenseKey =
//   '6cc56160b6a106c7e9a30ec08ac74ab469b02fdcf4eb87c7ab' +
//   '27ca7e274f5ccde74019f843ddf6b7fe1cf4d73d0fb31d7329f50e06c3f9e25d115e3fe9add0c' +
//   '3823ddafd979f8318578f630cd3b99cef842577cfe9abdbfeab421573ff0fcd66a0641820baa2' +
//   '3b923c505f47b8530dab330ed375acc39ae451e1e4e7db588bddd153aa68143d9acab0b41495c' +
//   'e96330915c204efcdcef65642b1ddb0c1d3256879754b48f7392793595d2ebb8b804148ded8b2' +
//   '0c78526496b3246dac604bb45890653849a91a602ff7f258ebe38500ad4453093b3c6d00ab326' +
//   '4ae9bd33630a15af836901d7009cb52dc8be6d64533161205c804de4e136f1d659d408fe375af';

@Component({
  components: {
    ScrapAgent,
    ribbon: Ribbon,
    'ds-navbar': DsNavbar,
    'show-more': ShowMore,
    logout: LogOutModal,
    'my-briefing-sidebar': MyBriefingSidebar,
    'my-report-sidebar': MyReportSidebar,
    'popup-system-upgrade': PopupSystemUpgrade,
    'popup-trial-exist-user': PopupTrialUserComponent,
    'add-reference': PopupAddReference,
    register: Register,
    'article-detail': ArticleDetail,
    'report-detail': myReports,
    'topic-detail': myTopics,
    'modal-create-agent-component': ModalCreateAgentComponent,
    'popup-update-briefing': PopupUpdateBriefing,
    'popup-alert-pin': PopupAlertPinComponent,
    'vue-custom-scrollbar': vueCustomScrollbar,
    'go-to-top-component': GoToTopComponent,
    'ds-navbar-guest': DsNavbarGuest,
    'share-report': ShareReport,
    'share-topic': ShareTopic,
    'popup-edit-report-ref': PopupEditReportRef,
    'popup-report-detail-setting-component': PopupReportDetailSettingComponent,
    'popup-report-warning-close-after-edit-component': PopupReportWarningCloseAfterEditComponent,
    'popup-plugin-download': PopupPluginDownload,
    'report-toast-component': ReportToastComponent,
    'go-list-end': GoListEndComponent,
    'popup-make-a-thon-component': PopupMakeAThonComponent,
    'popup-submit-report': PopupSubmitReportComponent,
    'popup-submit-report-success': PopupSubmitReportSuccessComponent,
    'company-widget-view-detail': CompanyWidgetViewDetail,
    'popup-login': LoginForm,
    'popup-required-login-component': PopupRequiredLoginComponent,
    'popup-register': () => import('@/account/register/popup-register.vue'),
    'popup-required-paid-account-component': PopupRequiredPaidAccountComponent,
    'popup-feature-limit': FeatureLimit,
    'my-create-sidebar': MyCreateSidebar,
  },
  mixins: [LoadingReportCardUtil],
  computed: {
    ...mapGetters('briefingStore', ['getCompanyWidgetDetail', 'getCompanyBpDetail']),
    companyWidgetDetail() {
      return this.getCompanyWidgetDetail;
    },
    companyBpDetail() {
      return this.getCompanyBpDetail;
    },
  },
})
export default class App extends Vue {
  @groupsManagerStore.Action
  public setlang!: (payload: { newVal: boolean }) => void;

  @appStoreState.Getter
  public isShowAddReference!: boolean;

  @briefingStore.Mutation
  public setAddingReferenceDocuments!: (payload: any) => void;

  @briefingStore.Getter
  getAddingResources!: Array<IResourceModel>;
  @briefingStore.Getter
  public getSelectedResource!: IResourceModel;
  @appStoreState.Getter
  public isShowDetailArticle!: boolean;
  @appStoreState.Getter
  public isShowDetailReport!: boolean;
  @appStoreState.Getter
  public isShowDetailTopic!: boolean;
  @appStoreState.Getter
  public isShowEditReportRef!: boolean;

  @appStoreState.Getter
  public isShowCreateBriefing!: boolean;

  @appStoreState.Getter
  public getIsShowAlertPinBriefing!: boolean;

  @appStoreState.Mutation
  public setShowDetailArticles!: (b: boolean) => void;
  @appStoreState.Mutation
  public setShowDetailReport!: (b: boolean) => void;
  @appStoreState.Mutation
  public setShowDetailTopic!: (b: boolean) => void;
  @briefingStore.Mutation
  public setSelectedResource!: (payload?: any) => void;

  @appStoreState.Getter
  public getIsShowShareReport: boolean;

  @appStoreState.Getter
  public getIsShowShareTopic: boolean;

  @appStoreState.Getter
  public getIsShowBackdrop: boolean;

  @appStoreState.Getter
  public getIsShowReportSettingReportType!: boolean;

  @appStoreState.Getter
  public getIsShowReportWarningCloseAfterEdit!: boolean;

  @appStoreState.Getter
  public getToastReportData!: any;

  @appStoreState.Mutation
  public setToastReportData!: (payload: any) => void;

  @briefingStore.Getter
  public getIsSelectReportNoBriefingTab!: boolean;

  @appStoreState.Getter
  public getIsShowPopupSubmitReport!: boolean;

  @appStoreState.Getter
  public getIsShowPopupSubmitReportSuccess!: boolean;

  @briefingStore.Mutation
  public setIsSelectReportNoBriefingTab!: (isSelectReportNoBriefingTab: boolean) => void;

  @Inject('websocketService')
  private websocketService: () => WebsocketService;

  @appStoreState.Mutation
  public setBpIdForReportWithBriefing!: (payload: string) => void;

  private paddingTopUnset = {};
  @Inject('principalService') private principalService: () => PrincipalService;
  @Inject('translationService') private translationService: () => TranslationService;
  @Inject('publicService') private publicService: () => PublicService;
  heatmapData = [];
  @appStoreState.Getter
  public isLoginPage!: boolean;
  @appStoreState.Action
  public changePage!: (payload: { isLoginPage: boolean }) => void;

  @appStoreState.Getter
  public getIsShowUpdateBriefing!: boolean;

  @appStoreState.Getter
  public getIsShowEditReportRef!: boolean;

  @appStoreState.Mutation
  public setIsShowUpdateBriefing!: (payload: any) => void;

  @appStoreState.Getter
  public getIsShowDeleteBriefing!: boolean;

  @appStoreState.Mutation
  public setDataReportNotify!: (payload: any) => void;

  @appStoreState.Mutation
  public setGoToTopClicked!: (payload: any) => void;

  @appStoreState.Getter
  public getReShowToastReport!: boolean;

  @appStoreState.Mutation
  public setReShowToastReport!: (payload: boolean) => void;

  @appStoreState.Getter
  public getIsOpenPopupEditReferenceForPage!: boolean;

  @appStoreState.Getter
  public getIsShowPopupRequiredLogin!: boolean;

  @appStoreState.Mutation
  public setIsShowPopupRequiredLogin!: (payload: boolean) => void;

  @appStoreState.Getter
  public getIsShowPopupLogin!: boolean;

  @appStoreState.Mutation
  public setIsShowPopupLogin!: (payload: boolean) => void;

  @appStoreState.Getter
  public getIsShowPopupRegister!: boolean;
  showScrapAgent: any = false;
  selectedScrapData = null;
  closeSuccesRequestId: string[] = [];

  // receive notifications from emit scrap modal
  @Provide()
  get emitGlobalEventShowScrapData() {
    return this.receiveEvent;
  }

  //----------------------------------------------------------------

  @appStoreState.Getter
  public getIsShowPopupRequiredPaidAccount!: boolean;

  @appStoreState.Getter
  public getIsShowFeatureLimit!: boolean;

  @appStoreState.Mutation
  public setDataPodcastNotify!: (payload: any) => void;

  loginPage = false;
  arrDocId: any[] = [];
  listContentReference: any[] = [];

  loadingReportCardUtil = new LoadingReportCardUtil();
  reportToastUtil = new ReportToastUtil();

  scrollSettings = {
    wheelPropagation: false,
  };

  isShowButtonGoToTop = false;
  reportDataSubscription: Subscription = null;
  podcastDataSubscription: Subscription = null;
  tempUserKey = JSON.parse(localStorage.getItem('localStorageUser'))?.id || '';
  briefingReportListSubscribe: BriefingReportSubscribe[] = [];
  subscriptionsReportWithBpId: { [key: string]: Subscription } = {};
  intervalAutoRemoveLoadingReportData;
  countReShowToastReportData = 0;
  isShowPopupMakeAThon = localStorage.getItem('isShowPopupMakeAThon') !== undefined ? localStorage.getItem('isShowPopupMakeAThon') : '1';
  reportTypesResult: [];
  reportTypesResultForBriefing: [];

  @Watch('heatmapData')
  onHeatmapChange() {
    if (this.heatmapData.length > 4) {
      axios.post('/api/heatmap', this.heatmapData).then(
        // @ts-ignore
        (this.heatmapData.length = 0)
      );
    }
  }

  @Watch('isLoginPage')
  detectLoginPage(isLoginPage) {
    this.loginPage = !isLoginPage;
  }

  changeStatePage(navigate, e, isLoginPage) {
    this.loginPage = !this.loginPage;
    navigate(e);
    this.changePage({ isLoginPage: isLoginPage });
  }

  queryString = window.location.search;
  param = new URLSearchParams(this.queryString).get('ds-id');

  @Watch('$route.fullPath')
  changePopup() {
    //
    setTimeout(() => {
      if (this.$route.query['ds-id']) {
        this.setShowDetailArticles(true);
        this.setSelectedResource({ bpId: this.param, type: 'DISCOVERY', docId: this.param });
      }
    }, 300);
  }

  @Watch('$route.fullPath')
  onRouteChange(path) {
    this.loginPage = path.split('/').includes('login');
    ['register', 'login'].some(e => path.split('/').includes(e))
      ? Object.assign(this.paddingTopUnset, { 'padding-top': 'unset !important' })
      : Object.assign(this.paddingTopUnset, {});

    /* close popup article/report details */
    this.setSelectedResource({});
    this.setShowDetailArticles(false);
    this.setShowDetailReport(false);
    this.setShowDetailTopic(false);
    this.showScrapAgent = false;
  }

  @Watch('isShowAddReference')
  onIsShowAddReferenceChange() {
    if (!this.isShowAddReference) {
      this.setAddingReferenceDocuments([]);
    }
  }

  @Watch('goToTopClicked')
  onGoToTopClickedChange(newValue) {
    if (newValue) {
      this.scrollToTop();
      this.setGoToTopClicked(false);
    }
  }

  get isGuest() {
    return checkIsGuestAccount();
  }

  get goToTopClicked() {
    return this.$store.getters['appStore/getGoToTopClicked'];
  }

  async created() {
    const makeAThonDueDate = localStorage.getItem('makeAThonDueDate');
    if (!makeAThonDueDate) {
      localStorage.setItem('makeAThonDueDate', DUE_DATE_MAKE_A_THON);
    }
    this.isShowPopupMakeAThon = isOutOfDateMakeAThon() ? '1' : '0';

    const current = window.location.href;
    if (current.split('/').includes('login')) {
      this.loginPage = true;
    }
    if (current.split('/').includes('register')) {
      this.loginPage = false;
    }
  }

  public changeLanguage(newLanguage: string): void {
    this.translationService().refreshTranslation(newLanguage);
    this.$store
      .dispatch('groupsManagerStore/loadUserContext', {
        connectomeId: this.principalService().getConnectomeInfo().connectomeId,
        language: newLanguage,
      })
      .then(res => {});
    this.$store.commit('setLang', newLanguage);
  }

  mounted() {
    this.autoRemoveOverTimeLoadingReportCardData();
    this.subscribeReportData();
    this.subscribePodcastData();
    this.restoreSubscriptionsReportWithBpId();
    this.addDefaultReadingMode();
  }

  @Watch('$route', { immediate: true, deep: true })
  async onRouterChange(newVal, oldVal) {
    if (newVal && oldVal) {
      // Show popup update
      let ip = sessionStorage.getItem('ip');
      if (!ip) {
        ip = await this.publicService()
          .getIpFromClient()
          .then((ip: string) => {
            sessionStorage.setItem('ip', ip);
            return ip;
          });
      }
      this.publicService()
        .getLocationByIp(ip)
        .then(res => {
          if (res.data.countryCode == 'KR') {
            const isHomePage = newVal.name == 'Home' && !newVal.fullPath.includes('?q=') && !newVal.fullPath.includes('?conversationId=');
            const savedDate = localStorage.getItem('DDT_DATE');
            const today = new Date().toISOString().slice(0, 10);
            // if (savedDate !== today && isHomePage) {
            //   // @ts-ignore
            //   window.$('#go-modal-notice-systemUpgrade').modal({
            //     show: true,
            //     backdrop: true,
            //   });
            // }
          }
        });
    }

    if (newVal && oldVal && newVal.fullPath && oldVal.fullPath) {
      if (newVal.fullPath !== oldVal.fullPath && oldVal.fullPath !== '/') {
        this.saveUserActivitiesChangeRoute();
      }
    }
  }

  @Watch('getToastReportData')
  onGetToastReportDataChange() {
    if (this.getToastReportData?.length > 0) {
      this.getToastReportData?.forEach(item => {
        if (
          item?.bpId &&
          item?.bpId !== undefined &&
          item?.bpId !== '' &&
          item?.bpId !== null &&
          item?.bpId?.trim()?.length > 0 &&
          item?.status === REPORT_TOAST_STATUS.LOADING
        ) {
          this.subscribeReportWithBpId(item?.bpId, false);
        }
        if (item.status === REPORT_TOAST_STATUS.SUCCESS && this.closeSuccesRequestId.includes(item.requestId)) {
          this.handleRemoveToastReportDataByRequestId(item.requestId);
        }
      });
      this.autoRemoveOverTimeLoadingReportCardData();
    }
  }

  @Watch('getReShowToastReport')
  onGetReShowToastReportChange() {
    this.countReShowToastReportData++;
    this.handleReShowLoadingReportToast();
  }

  selectComponent(arrDocId) {
    this.arrDocId = arrDocId;
  }

  getAllContentReference(listContentReference) {
    this.listContentReference = listContentReference;
  }

  saveUserActivitiesChangeRoute() {
    const userActivityLog = new UserActivityLogModel();
    userActivityLog.connectomeId = this.principalService().getConnectomeInfo().connectomeId;
    userActivityLog.userLanguage = this.$store.getters.currentLanguage ? this.$store.getters.currentLanguage : '';
    userActivityLog.userId = this.principalService().getUserInfo()?.id || '';
    const token = this.principalService().getToken();
    if (!token) {
      return;
    }
    axios.post('api/user-activity-log/saveChangeUrl', userActivityLog).then();
  }

  public get authenticated(): boolean {
    return this.$store.getters.authenticated;
  }

  logout() {
    // @ts-ignore
    this.$refs.logout.logout();
  }

  reloadBriefingPage(newBriefingPage) {
    // @ts-ignore
    this.$refs.userSidebar?.getAllBriefingPage(0);
  }

  updateScrapAgentSuccess() {
    this.showScrapAgent = false;
    this.$bvToast.toast(`${this.$t('scrap-agent.toast.update-scrap.messSuccess')}`, {
      toaster: 'b-toaster-bottom-right',
      title: `${this.$t('scrap-agent.toast.success')}`,
      variant: 'success',
      solid: true,
      autoHideDelay: 5000,
    });
  }

  // changeIsShowHeatMap() {
  //   this.isShowHeatMap = !this.isShowHeatMap;
  //   if (this.isShowHeatMap) {
  //     this.initHeatmap();
  //   } else {
  //     if (document.getElementsByClassName('heatmap-canvas').length > 0) {
  //       document.querySelector('.heatmap-canvas').remove();
  //     }
  //   }
  // }

  // initHeatmap() {
  //   const heatmapInstance = h337.create({
  //     container: document.querySelector('body'),
  //     radius: 60,
  //   });
  //   // @ts-ignore
  //   document.querySelector('.heatmap-canvas').style.zIndex = '100';
  //   axios.get('/api/heatmap').then(res => {
  //     const data = {
  //       max: res.data.maxValue,
  //       min: 0,
  //       data: res.data.heatmaps,
  //     };
  //     heatmapInstance.setData(data);
  //   });
  // }

  handleScroll(e: any) {
    try {
      const scrollTop = e.target.scrollTop;

      if (scrollTop >= 10) {
        if (!this.isShowButtonGoToTop) {
          this.isShowButtonGoToTop = true;
        }
      } else {
        if (this.isShowButtonGoToTop) {
          this.isShowButtonGoToTop = false;
        }
      }
    } catch (e) {
      this.isShowButtonGoToTop = false;
    }
  }

  scrollToTop() {
    try {
      $('#container-block').animate({ scrollTop: 0 }, 'fast');
    } catch (e) {
      // todo
    }
  }

  public get userIdentity(): any {
    return this.$store.getters?.account
      ? this.$store.getters?.account
      : this.$store.getters?.userIdentity
      ? this.$store.getters?.userIdentity
      : JSON.parse(localStorage.getItem('localStorageUser'))
      ? JSON.parse(localStorage.getItem('localStorageUser'))
      : null;
  }

  subscribeReportData() {
    try {
      /* subscribe for real-time append report no briefing */
      if (this.reportDataSubscription) {
        this.reportDataSubscription.unsubscribe();
      }

      if (!this.tempUserKey) {
        this.tempUserKey =
          this.userIdentity?.id || JSON.parse(localStorage.getItem('localStorageUser'))?.id || this.$store.getters?.userIdentity?.id;
      }

      let tempListReportNotify = [];
      let tempToastReportData: ToastReportData = {
        id: '',
        requestId: '',
        bpId: '',
        addedTime: 0,
        status: '',
        statusCode: '',
        notifyReportData: undefined,
        isReShow: false,
        type: undefined,
        reportTypesResult: [],
        reportTypesResultForBriefing: [],
      };

      this.reportDataSubscription = this.websocketService().subscribeReportData('reportData', this.tempUserKey, {
        next: (data: any) => {
          this.setDataReportNotify(data);
          if (data && data?.length > 0 && (!data?.status || data?.status !== 'FAIL')) {
            tempListReportNotify = data
              ?.filter(item => item?.parentDocDetail && (item?.requestId || item?.parentDocDetail?.request_id))
              ?.map(item => ({
                ...item,
                requestId: item?.requestId || item?.parentDocDetail?.request_id || '',
              }))
              ?.filter(item => item.requestId !== undefined && item.requestId !== null && item.requestId !== '');

            if (tempListReportNotify?.length > 0) {
              const typeString = this.loadingReportCardUtil.makeConcatStringByMediaType(tempListReportNotify?.[0]);

              tempToastReportData = {
                id: tempListReportNotify?.[0]?.parentDocDetail?.parent_doc_id?.[0] || '',
                requestId: tempListReportNotify?.[0]?.requestId.concat(typeString) || '',
                bpId: '',
                addedTime: new Date().getTime(),
                status: REPORT_TOAST_STATUS.SUCCESS,
                statusCode: REPORT_TOAST_STATUS_CODE.SUCCESS,
                notifyReportData: tempListReportNotify?.[0] ? map2ResourceItem(tempListReportNotify?.[0]) : '',
                isReShow: false,
                type: this.reportToastUtil.removeLeadingUnderscores(typeString),
                reportTypesResult: this.reportTypesResult,
                reportTypesResultForBriefing: [],
              };
            }
          } else if (data?.status && data?.status === 'FAIL' && data?.statusCode) {
            const typeString = this.loadingReportCardUtil.makeConcatStringByMediaType(data);

            tempToastReportData = {
              id: data?.id || '',
              requestId: data?.requestId.concat(typeString) || '',
              bpId: '',
              addedTime: new Date().getTime(),
              status: REPORT_TOAST_STATUS.FAILED,
              statusCode: data?.statusCode || REPORT_TOAST_STATUS_CODE.SYSTEM_ERROR,
              notifyReportData: undefined,
              isReShow: false,
              type: this.reportToastUtil.removeLeadingUnderscores(typeString),
            };
          }

          if (tempToastReportData && tempToastReportData.requestId !== undefined && tempToastReportData.requestId !== '') {
            this.updateToastData(tempToastReportData);
            this.loadingReportCardUtil.handleRemoveLoadingCardByNotifyDataOrAPIData([tempToastReportData.requestId]);
            this.autoRemoveToastReport(tempToastReportData?.requestId || '');
          }

          this.autoRemoveOverTimeLoadingReportCardData();
        },
      });
    } catch (e) {
      console.log('subscribeReportData error:', e);
    }
  }

  subscribePodcastData() {
    try {
      if (this.podcastDataSubscription) {
        this.podcastDataSubscription.unsubscribe();
      }

      if (!this.tempUserKey) {
        this.tempUserKey =
          this.userIdentity?.id || JSON.parse(localStorage.getItem('localStorageUser'))?.id || this.$store.getters?.userIdentity?.id;
      }

      let tempListPodcastNotify = [];
      let tempToastPodcastData: ToastReportData = {
        id: '',
        requestId: '',
        bpId: '',
        addedTime: 0,
        status: '',
        statusCode: '',
        notifyReportData: undefined,
        isReShow: false,
        type: undefined,
      };

      this.podcastDataSubscription = this.websocketService().subscribeGetPodcastSetting(this.tempUserKey, {
        next: (data: any) => {
          if (data && data?.length > 0) {
            tempListPodcastNotify = data
              ?.filter(item => item?.data?.data && (item?.request_id || item?.data?.request_id || item?.data?.data?.request_id))
              ?.map(item => ({
                ...item,
                requestId: item?.request_id || item?.data?.request_id || item?.data?.data?.request_id || '',
              }))
              ?.filter(item => item.requestId !== undefined && item.requestId !== null && item.requestId !== '')
              ?.filter(item => item?.requestId?.includes('CRNBP_'));

            if (tempListPodcastNotify?.length > 0) {
              tempToastPodcastData = {
                id: tempListPodcastNotify?.[0]?._id || '',
                requestId: tempListPodcastNotify?.[0]?.requestId.concat('_' + LOADING_DATA_TYPE.PODCAST.toString()) || '',
                bpId: '',
                addedTime: new Date().getTime(),
                status: REPORT_TOAST_STATUS.SUCCESS,
                statusCode: REPORT_TOAST_STATUS_CODE.SUCCESS,
                notifyReportData: undefined,
                isReShow: false,
                type: LOADING_DATA_TYPE.PODCAST.toString(),
              };
            }
          }

          if (tempToastPodcastData && tempToastPodcastData.requestId !== undefined && tempToastPodcastData.requestId !== '') {
            this.setDataPodcastNotify(tempToastPodcastData);
            this.updateToastData(tempToastPodcastData);
            this.autoRemoveToastReport(tempToastPodcastData?.requestId || '');
          }

          this.autoRemoveOverTimeLoadingReportCardData();
        },
      });
    } catch (e) {
      console.log('subscribePodcastData error:', e);
    }
  }

  async subscribeReportWithBpId(bpIdInput: string, isReSubscribe: boolean) {
    if (bpIdInput && bpIdInput.trim().length > 0) {
      try {
        if (!this.tempUserKey) {
          this.tempUserKey =
            this.userIdentity?.id || JSON.parse(localStorage.getItem('localStorageUser'))?.id || this.$store.getters?.userIdentity?.id;
        }

        if (this.briefingReportListSubscribe?.some(item => item?.id === bpIdInput) && !isReSubscribe) {
          this.briefingReportListSubscribe = this.briefingReportListSubscribe.map(item => {
            if (item.id === bpIdInput) {
              return {
                ...item,
                addedTime: new Date().getTime(),
              };
            }
            return item;
          });
        }

        if (!this.briefingReportListSubscribe?.some(item => item?.id === bpIdInput) || isReSubscribe) {
          // console.log('subscribeReportWithBpId: ', bpIdInput);
          const tempData: BriefingReportSubscribe = {
            id: bpIdInput || '',
            addedTime: new Date().getTime(),
          };
          this.briefingReportListSubscribe.push(tempData);

          this.saveBpIdToLocalStorageToReSubscribeReportWithBpId();

          let tempListReportNotify = [];
          let tempToastReportData: ToastReportData = {
            id: '',
            requestId: '',
            bpId: '',
            addedTime: 0,
            status: '',
            statusCode: '',
            notifyReportData: undefined,
            isReShow: false,
            type: undefined,
            reportTypesResult: [],
            reportTypesResultForBriefing: [],
          };

          this.subscriptionsReportWithBpId[bpIdInput] = this.websocketService().subscribeBriefingResource(bpIdInput, this.tempUserKey, {
            next: async (data: any) => {
              this.setDataReportNotify(data);

              if (data && data.length > 0 && (!data?.status || data?.status !== 'FAIL')) {
                tempListReportNotify = data
                  ?.filter(item => item?.parentDocDetail && (item?.requestId || item?.parentDocDetail?.request_id))
                  ?.map(item => ({
                    ...item,
                    requestId: item?.requestId || item?.parentDocDetail?.request_id || '',
                  }))
                  ?.filter(item => item.requestId !== undefined && item.requestId !== null && item.requestId !== '');

                if (tempListReportNotify?.length > 0) {
                  const typeString = this.loadingReportCardUtil.makeConcatStringByMediaType(tempListReportNotify?.[0]);

                  tempToastReportData = {
                    id: tempListReportNotify?.[0]?.parentDocDetail?.parent_doc_id?.[0] || '',
                    requestId: tempListReportNotify?.[0]?.requestId.concat(typeString) || '',
                    bpId: tempListReportNotify?.[0]?.bpId || bpIdInput || '',
                    addedTime: new Date().getTime(),
                    status: REPORT_TOAST_STATUS.SUCCESS,
                    statusCode: REPORT_TOAST_STATUS_CODE.SUCCESS,
                    notifyReportData: tempListReportNotify?.[0] ? map2ResourceItem(tempListReportNotify?.[0]) : '',
                    isReShow: false,
                    type: this.reportToastUtil.removeLeadingUnderscores(typeString),
                    reportTypesResult: this.reportTypesResult,
                    reportTypesResultForBriefing: this.reportTypesResultForBriefing,
                  };
                }
              } else if (data?.status && data?.status === 'FAIL' && data?.statusCode) {
                const typeString = this.loadingReportCardUtil.makeConcatStringByMediaType(data);

                tempToastReportData = {
                  id: data?.id || '',
                  requestId: data?.requestId.concat(typeString) || '',
                  bpId: data?.bpId || bpIdInput || '',
                  addedTime: new Date().getTime(),
                  status: REPORT_TOAST_STATUS.FAILED,
                  statusCode: data?.statusCode || REPORT_TOAST_STATUS_CODE.SYSTEM_ERROR,
                  notifyReportData: undefined,
                  isReShow: false,
                  type: this.reportToastUtil.removeLeadingUnderscores(typeString),
                };
              }

              if (tempToastReportData && tempToastReportData.requestId !== undefined && tempToastReportData.requestId !== '') {
                this.updateToastData(tempToastReportData);

                if (!this.briefingReportListSubscribe?.some(item => item?.id === bpIdInput)) {
                  await this.unsubscribeReportWithBpId(bpIdInput);
                } else {
                  const tempList = this.briefingReportListSubscribe?.filter(item => item?.id === bpIdInput);

                  if (tempList?.length === 1) {
                    await this.unsubscribeReportWithBpId(bpIdInput);
                  }
                }

                this.loadingReportCardUtil.handleRemoveLoadingCardByNotifyDataOrAPIData([tempToastReportData.requestId]);
                this.autoRemoveToastReport(tempToastReportData?.requestId || '');
              }

              this.autoRemoveOverTimeLoadingReportCardData();
            },
          });
        }
      } catch (e) {
        console.log('subscribeBriefingResource error:', e);
      }
    }
  }

  handleRemoveToastReportDataByRequestId(requestIdInput: string) {
    if (requestIdInput?.trim()?.length > 0) {
      if (this.getToastReportData?.length > 0) {
        if (
          !this.closeSuccesRequestId.includes(requestIdInput) &&
          this.getToastReportData?.some(item => item?.requestId === requestIdInput && item.status === REPORT_TOAST_STATUS.SUCCESS)
        ) {
          this.closeSuccesRequestId.push(requestIdInput);
          setTimeout(() => (this.closeSuccesRequestId = []), 15000);
        }
        const tempList = this.getToastReportData?.filter(item => item?.requestId !== requestIdInput) || [];

        if (tempList?.length > 0) {
          this.reportToastUtil.setLoadingDataReportToastListLocalStorage(tempList);
          this.setToastReportData(tempList);
        } else {
          this.reportToastUtil.setLoadingDataReportToastListLocalStorage([]);
          this.setToastReportData([]);
        }

        let retryCount = 0;
        const maxRetries = 50;

        const checkAndRetry = () => {
          const isOnState = this.getToastReportData?.some(item => item?.requestId === requestIdInput) || false;
          let isOnLocal = false;
          const tempData = this.reportToastUtil.getLoadingDataReportToastListLocalStorage();

          if (tempData?.length > 0) {
            try {
              const parsedData = JSON.parse(tempData);
              isOnLocal = parsedData?.some?.(item => item?.requestId === requestIdInput) || false;
            } catch (error) {
              isOnLocal = false;
            }
          }

          if (!isOnState && !isOnLocal) {
            return;
          }

          retryCount++;

          if (retryCount < maxRetries) {
            setTimeout(checkAndRetry, 100);
          }
        };

        setTimeout(checkAndRetry, 100);
      }
    }
  }

  handleOpenReportDetail(notifyReportData: any, requestIdInput: string) {
    if (notifyReportData && notifyReportData !== '' && (notifyReportData?.docId || notifyReportData?._id)) {
      const tempId = notifyReportData?.docId || notifyReportData?._id || '';

      if (tempId && tempId !== '') {
        if (this.isShowDetailReport) {
          this.setShowDetailReport(false);
        }

        this.$nextTick(() => {
          setTimeout(() => {
            if (requestIdInput?.trim()?.length > 0) {
              this.handleRemoveToastReportDataByRequestId(requestIdInput);
            }

            this.setSelectedResource(notifyReportData);
            this.setShowDetailReport(true);
          }, 100);
        });
      }
    }
  }

  handleGoToPage(requestIdInput: string, pageInput: string) {
    if (requestIdInput?.trim()?.length > 0) {
      this.handleRemoveToastReportDataByRequestId(requestIdInput);
    }

    // console.log('pageInput: ', pageInput)

    this.$nextTick(() => {
      setTimeout(() => {
        let target = '/my-create/report';

        if (pageInput === LOADING_DATA_TYPE.REPORT.toString()) {
          target = '/my-create/report';
        } else if (pageInput === LOADING_DATA_TYPE.JOURNALIST_NOTE.toString()) {
          target = '/my-create/journalist-note';
        } else if (pageInput === LOADING_DATA_TYPE.SOCIAL_MEDIA_POSTING.toString()) {
          target = '/my-create/social-media-posting';
        } else if (pageInput === LOADING_DATA_TYPE.PODCAST.toString()) {
          target = '/my-create/podcast';
        }

        window.location.href = target;
      }, 1);
    });
  }

  handleGoToBriefingPage(bpIdInput: string, requestIdInput: string) {
    if (bpIdInput?.trim()?.length > 0) {
      if (this.$route.fullPath !== `/my-briefing/${bpIdInput}`) {
        this.$router
          .push(`/my-briefing/${bpIdInput}`)
          .then(() => {
            this.setBpIdForReportWithBriefing(bpIdInput);
          })
          .catch(err => {
            console.error('Navigation error:', err);
          });
      } else {
        this.setBpIdForReportWithBriefing(bpIdInput);
      }
    }

    if (requestIdInput?.trim()?.length > 0) {
      this.handleRemoveToastReportDataByRequestId(requestIdInput);
    }
  }

  restoreSubscriptionsReportWithBpId(): void {
    const localStorageReportBpIdListSubscribe = this.getLocalStorageReportBpIdListSubscribe();

    if (localStorageReportBpIdListSubscribe && localStorageReportBpIdListSubscribe?.trim()?.length > 0) {
      let tempList = JSON.parse(localStorageReportBpIdListSubscribe);

      if (tempList?.length > 0) {
        // remove over time loading report data
        tempList = tempList.filter(item => item?.addedTime && new Date().getTime() - item?.addedTime < MAX_TIME_OUT_FOR_LOADING_REPORT);

        if (tempList?.length > 0) {
          this.briefingReportListSubscribe = tempList;
          this.setLocalStorageReportBpIdListSubscribe(tempList);
        } else {
          this.briefingReportListSubscribe = [];
          this.setLocalStorageReportBpIdListSubscribe('');
          this.setLocalStorageReportBpIdListSubscribe('');
        }
      }

      if (tempList?.length > 0) {
        tempList.forEach(item => {
          // console.log('call subcribe item: ', item);
          this.subscribeReportWithBpId(item.id, true);
        });
      }
    }
  }

  saveBpIdToLocalStorageToReSubscribeReportWithBpId(): void {
    if (this.briefingReportListSubscribe?.length > 0) {
      this.setLocalStorageReportBpIdListSubscribe(this.briefingReportListSubscribe);
    } else {
      this.setLocalStorageReportBpIdListSubscribe('');
    }
  }

  async unsubscribeReportWithBpId(bpIdInput: string) {
    const tempSubscriptionReportWithBpId = this.subscriptionsReportWithBpId[bpIdInput];

    if (tempSubscriptionReportWithBpId) {
      tempSubscriptionReportWithBpId.unsubscribe();

      delete this.subscriptionsReportWithBpId[bpIdInput];
    }

    this.briefingReportListSubscribe = this.briefingReportListSubscribe.filter(itemData => itemData.id !== bpIdInput);

    this.saveBpIdToLocalStorageToReSubscribeReportWithBpId();
  }

  autoRemoveToastReport(requestIdInput: string) {
    setTimeout(() => {
      this.handleRemoveToastReportDataByRequestId(requestIdInput || '');
    }, TIME_DISPLAY_SUCCESS_TOAST_REPORT);
  }

  updateToastData(toastReportDataInput: ToastReportData) {
    if (this.getToastReportData?.length > 0) {
      let isExisted = false;
      const tempList = this.getToastReportData?.map(item => {
        if (
          (item?.requestId === toastReportDataInput?.requestId && item.status === REPORT_TOAST_STATUS.LOADING) ||
          (toastReportDataInput?.requestId.includes(item?.requestId) && //Goover again succes concat _REPORT at the end
            item.requestId.startsWith('GOA') &&
            item.reportTypesResult.length === 1 &&
            item.status === REPORT_TOAST_STATUS.LOADING)
        ) {
          isExisted = true;
          const tempBpId =
            toastReportDataInput?.bpId?.length > 0 ? toastReportDataInput?.bpId : (item?.bpId?.length > 0 ? item?.bpId : '') || '';
          toastReportDataInput.bpId = tempBpId || '';
          if (toastReportDataInput && !toastReportDataInput.reportTypesResult) {
            toastReportDataInput.reportTypesResult = item.reportTypesResult;
          }
          if (toastReportDataInput && !toastReportDataInput.reportTypesResultForBriefing) {
            toastReportDataInput.reportTypesResultForBriefing = item.reportTypesResultForBriefing;
          }
          return toastReportDataInput;
        } else {
          return item;
        }
      });
      if (tempList?.length > 0) {
        if (isExisted) {
          this.reportToastUtil.setLoadingDataReportToastListLocalStorage([...tempList]);
          this.setToastReportData([...tempList]);
        } else {
          this.reportToastUtil.setLoadingDataReportToastListLocalStorage([toastReportDataInput, ...tempList]);
          this.setToastReportData([toastReportDataInput, ...tempList]);
        }
      }
    } else {
      this.reportToastUtil.setLoadingDataReportToastListLocalStorage([toastReportDataInput]);
      this.setToastReportData([toastReportDataInput]);
    }
  }

  getLocalStorageReportBpIdListSubscribe() {
    return localStorage.getItem('localStorageReportBpIdListSubscribe') || '';
  }

  setLocalStorageReportBpIdListSubscribe(inputData: any) {
    localStorage.setItem('localStorageReportBpIdListSubscribe', JSON.stringify(inputData || ''));
  }

  autoRemoveOverTimeLoadingReportCardData() {
    if (this.intervalAutoRemoveLoadingReportData) {
      clearInterval(this.intervalAutoRemoveLoadingReportData);
      this.intervalAutoRemoveLoadingReportData = null;
    }

    let isEmptyLoadingReportCardData = false;
    let isEmptyLoadingReportToastDataHasBpId = false;
    let isEmptyLoadingReportToastData = false;
    let isEmptyLoadingReportToastDataLocalStorage = false;

    this.intervalAutoRemoveLoadingReportData = setInterval(() => {
      // remove over time loading report toast data has BpId
      const localStorageReportBpIdListSubscribe = this.getLocalStorageReportBpIdListSubscribe();

      if (localStorageReportBpIdListSubscribe && localStorageReportBpIdListSubscribe?.trim()?.length > 0) {
        let tempList = JSON.parse(localStorageReportBpIdListSubscribe);

        if (tempList?.length > 0) {
          tempList = tempList.filter(item => item?.addedTime && new Date().getTime() - item?.addedTime < MAX_TIME_OUT_FOR_LOADING_REPORT);

          if (tempList?.length > 0) {
            this.setLocalStorageReportBpIdListSubscribe(tempList);
          } else {
            this.setLocalStorageReportBpIdListSubscribe('');
            isEmptyLoadingReportToastDataHasBpId = true;
          }
        } else {
          isEmptyLoadingReportToastDataHasBpId = true;
        }
      } else {
        isEmptyLoadingReportToastDataHasBpId = true;
      }

      // remove over time loading report toast data
      if (this.getToastReportData?.length > 0) {
        const tempList = this.getToastReportData.filter(
          item => item?.addedTime && new Date().getTime() - item?.addedTime < MAX_TIME_OUT_FOR_LOADING_REPORT
        );

        if (tempList?.length > 0) {
          this.setToastReportData(tempList);
        } else {
          this.setToastReportData([]);
          isEmptyLoadingReportToastData = true;
        }
      } else {
        isEmptyLoadingReportToastData = true;
      }

      // remove over time loading report toast data localStorage
      const localStorageLoadingDataReportToastList = this.reportToastUtil.getLoadingDataReportToastListLocalStorage();

      if (localStorageLoadingDataReportToastList?.length > 0) {
        let tempList = JSON.parse(localStorageLoadingDataReportToastList);

        if (tempList?.length > 0) {
          tempList = tempList.filter(item => item?.addedTime && new Date().getTime() - item?.addedTime < MAX_TIME_OUT_FOR_LOADING_REPORT);

          if (tempList?.length > 0) {
            this.reportToastUtil.setLoadingDataReportToastListLocalStorage(tempList);
          } else {
            this.reportToastUtil.setLoadingDataReportToastListLocalStorage([]);
            isEmptyLoadingReportToastDataLocalStorage = true;
          }
        } else {
          isEmptyLoadingReportToastDataLocalStorage = true;
        }
      } else {
        isEmptyLoadingReportToastDataLocalStorage = true;
      }

      // remove over time loading report card data
      const loadingReportCardData = this.loadingReportCardUtil.getLoadingDataReportCardListLocalStorage();

      if (loadingReportCardData && loadingReportCardData?.trim()?.length > 0) {
        let tempList = JSON.parse(loadingReportCardData);

        if (tempList?.length > 0) {
          tempList = tempList.filter(item => item?.addedTime && new Date().getTime() - item?.addedTime < MAX_TIME_OUT_FOR_LOADING_REPORT);

          if (tempList?.length > 0) {
            this.loadingReportCardUtil.setLoadingDataReportCardListLocalStorage(tempList);
          } else {
            this.loadingReportCardUtil.setLoadingDataReportCardListLocalStorage([]);
            isEmptyLoadingReportCardData = true;
          }
        } else {
          isEmptyLoadingReportCardData = true;
        }
      } else {
        isEmptyLoadingReportCardData = true;
      }

      if (
        isEmptyLoadingReportCardData &&
        isEmptyLoadingReportToastDataHasBpId &&
        isEmptyLoadingReportToastData &&
        isEmptyLoadingReportToastDataLocalStorage
      ) {
        if (this.intervalAutoRemoveLoadingReportData) {
          clearInterval(this.intervalAutoRemoveLoadingReportData);
          this.intervalAutoRemoveLoadingReportData = null;
        }
      }
    }, TIME_CHECK_LOADING_REPORT);
  }

  addDefaultReadingMode() {
    localStorage.setItem('reading-mode', 'false');
  }

  async receiveEvent(data: dataEvents) {
    this.showScrapAgent = data.events;
    this.selectedScrapData = data.data;
    await this.$nextTick();
  }

  handleReShowLoadingReportToast() {
    if (this.countReShowToastReportData === 1) {
      setTimeout(() => {
        if (!this.getToastReportData || this.getToastReportData?.length === 0) {
          const localStorageLoadingToastData = this.reportToastUtil.getLoadingDataReportToastListLocalStorage();

          if (localStorageLoadingToastData?.length > 0) {
            let parsedData = JSON.parse(localStorageLoadingToastData);

            if (parsedData?.length > 0) {
              parsedData = parsedData.filter(
                item =>
                  new Date().getTime() - item?.addedTime < MAX_TIME_OUT_FOR_LOADING_REPORT && item.status === REPORT_TOAST_STATUS.LOADING
              );

              if (parsedData?.length > 0) {
                parsedData = Array.from(new Map(parsedData?.map(item => [item.requestId, item])).values());

                if (parsedData?.length > 0) {
                  parsedData = parsedData.map(item => ({ ...item, isReShow: true }));
                  this.setToastReportData(parsedData);
                }
              }
            }
          }
        }
      }, 100);
    }
  }

  handleRemoveToastReportDataByListRequestIds(requestIdsInput: string[]) {
    if (requestIdsInput?.length > 0) {
      if (this.getToastReportData?.length > 0) {
        const tempList = this.getToastReportData?.filter(item => !requestIdsInput?.includes(item?.requestId)) || [];

        if (tempList?.length > 0) {
          this.reportToastUtil.setLoadingDataReportToastListLocalStorage(tempList);
          this.setToastReportData(tempList);
          this.setLocalStorageReportBpIdListSubscribe(tempList);
        } else {
          this.reportToastUtil.setLoadingDataReportToastListLocalStorage([]);
          this.setToastReportData([]);
        }

        let retryCount = 0;
        const maxRetries = 50;

        const checkAndRetry = () => {
          const isOnState = this.getToastReportData?.some(item => requestIdsInput?.includes(item?.requestId)) || false;
          let isOnLocal = false;
          const tempData = this.reportToastUtil.getLoadingDataReportToastListLocalStorage();

          if (tempData?.length > 0) {
            try {
              const parsedData = JSON.parse(tempData);
              isOnLocal = parsedData?.some(item => requestIdsInput?.includes(item?.requestId)) || false;
            } catch (error) {
              isOnLocal = false;
            }
          }

          if (!isOnState && !isOnLocal) {
            return;
          }

          retryCount++;

          if (retryCount < maxRetries) {
            setTimeout(checkAndRetry, 100);
          }
        };

        setTimeout(checkAndRetry, 100);
      }
    }
  }

  getReportTypesResult(value) {
    this.reportTypesResult = value;
  }

  getReportTypesResultForBriefing(value) {
    this.reportTypesResultForBriefing = value;
  }
}
